module.exports = __webpack_public_path__ + "static/media/636.d6be296e.webp";